var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.668 7.48383H12.0013",
    stroke: "#3263E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.668 10.1479H12.0013",
    stroke: "#3263E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11328 10.8162C4.25071 10.4256 4.50602 10.0872 4.84396 9.84784C5.18191 9.60847 5.58582 9.47992 5.99995 9.47992C6.41408 9.47992 6.81799 9.60847 7.15594 9.84784C7.49388 10.0872 7.74919 10.4256 7.88661 10.8162",
    stroke: "#3263E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0013 9.48252C6.73768 9.48252 7.33464 8.88557 7.33464 8.14919C7.33464 7.41281 6.73768 6.81586 6.0013 6.81586C5.26492 6.81586 4.66797 7.41281 4.66797 8.14919C4.66797 8.88557 5.26492 9.48252 6.0013 9.48252Z",
    stroke: "#3263E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 4.14789H2.66536C1.92898 4.14789 1.33203 4.74484 1.33203 5.48122V12.1479C1.33203 12.8843 1.92898 13.4812 2.66536 13.4812H13.332C14.0684 13.4812 14.6654 12.8843 14.6654 12.1479V5.48122C14.6654 4.74484 14.0684 4.14789 13.332 4.14789Z",
    stroke: "#3263E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanicon);
export default __webpack_public_path__ + "static/media/panicon.8d709216ec111b34d3580c2dc42b3059.svg";
export { ForwardRef as ReactComponent };